import React from 'react';
import clsx from 'clsx';
import { ADividerProps, ADividerOrientation } from './ADivider.types';
import * as Styled from './ADivider.styles';

const COMPONENT_NAME = 'a-web-ui-kit-ADivider';
const TEST_ID = 'web-ui-kit-ADivider';

export const ADivider: React.FC<ADividerProps> = ({
  orientation = ADividerOrientation.Horizontal,
  className,
  ...rest
}) => {
  return (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      orientation={orientation}
      className={clsx(className, 't-horizontal-vertical-rule')}
      {...rest}
    />
  );
};

export { ADividerOrientation, TEST_ID as A_DIVIDER_TEST_ID };
